// extracted by mini-css-extract-plugin
module.exports = {"speech-card-box":"f-","speechCardBox":"f-","speech-img-box":"f_","speechImgBox":"f_","card-content":"ga","cardContent":"ga","card-src":"gb","cardSrc":"gb"};